import './InternalNoteReport.css';

// Keys and labels follow REPORT_FIELDS in services-sure cognitive/tools/note.py
const REPORT_FIELDS = [
  ['trigger', 'Trigger'],
  ['stage', 'Stage'],
  ['request', 'Request'],
  ['checked', 'Checked'],
  ['blocker', 'Blocker'],
  ['missing', 'Missing'],
];

export const getInternalNoteReportRows = (report) => {
  if (!report || typeof report !== 'object') return [];

  return REPORT_FIELDS.map(([key, label]) => ({
    key,
    label,
    value: typeof report[key] === 'string' ? report[key].trim() : '',
  })).filter((row) => row.value);
};

const InternalNoteReport = ({ rows }) => (
  <dl className="internal-note-report">
    {rows.map((row) => (
      <div key={row.key} className="internal-note-report__row">
        <dt className="internal-note-report__label">{row.label}</dt>
        <dd className="internal-note-report__value">{row.value}</dd>
      </div>
    ))}
  </dl>
);

export default InternalNoteReport;
